import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import {
    amountDataTableTemplate,
    numberWithCommaDataTableTemplate,
    priceDataTableTemplate,
    rateMultipliedByOneHundredDataTableTemplate
} from "../../../utils/formatters/Numbers";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const ConfirmExtensionAdmin = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title={
                            props.isAdmin ? "Operación \\ Prórrogas Administrativas \\ Confirmar Prórroga"
                                : "Tablero de Control \\ Confirmar Prórroga"
                        }/>
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{textAlign: 'right'}}>
                            <Button
                                label="Regresar"
                                className="p-button-secondary"
                                onClick={props.handleReturnButton}/>
                            <Button
                                label="Rechazar"
                                className="p-button-secondary"
                                onClick={props.rejectExtension}/>
                            <Button
                                label="Confirmar" disabled={props.isLoading}
                                onClick={props.confirmExtension}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Préstamo" isBold={true}/>
                        <DataTable
                            value={props.loan}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column
                                field="emisora"
                                header="Emisora"/>
                            <Column
                                field="cantPrestamo"
                                header="Títulos"
                                style={{textAlign: 'right'}}
                                body={numberWithCommaDataTableTemplate}/>
                            <Column
                                field="precio24Hrs"
                                header="Precio"
                                style={{textAlign: 'right'}}
                                body={priceDataTableTemplate}/>
                        </DataTable>
                    </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Prórroga" isBold={true}/>
                        <DataTable
                            value={props.extension}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column
                                field="maturity"
                                header="Plazo"
                                style={{textAlign: 'right'}}
                                body={numberWithCommaDataTableTemplate}
                            />
                            <Column
                                field="rate"
                                header="Tasa"
                                style={{textAlign: 'right'}}
                                body={rateMultipliedByOneHundredDataTableTemplate}/>
                            <Column
                                field="surcharge"
                                header="Sobretasa"
                                style={{textAlign: 'right'}}
                                body={rateMultipliedByOneHundredDataTableTemplate}/>
                            <Column
                                field="reward"
                                header="Premio"
                                style={{textAlign: 'right'}}
                                body={amountDataTableTemplate}/>
                        </DataTable>
                    </Grid>
                    <Grid item xs={12}>
                        <SubtitleLabel header="Garantías" isBold={true}/>
                        <DataTable
                            value={props.guarantee}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column
                                field="emisora"
                                header="Emisora"/>
                            <Column
                                field="titulos"
                                header="Títulos"
                                style={{textAlign: 'right'}}
                                body={numberWithCommaDataTableTemplate}/>
                            <Column
                                field="precioMercado"
                                header="Precio"
                                style={{textAlign: 'right'}}
                                body={priceDataTableTemplate}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default ConfirmExtensionAdmin;